import { useReactTable, getCoreRowModel, createColumnHelper } from '@tanstack/react-table';
import { Grocery } from '../../Clients/reminds';
import Table from '../../Components/Table/Table';
import { useGroceriesContext } from '../../Contexts/Groceries.Context';
import { Remove } from '../../Icons/Remove';

const columnHelper = createColumnHelper<Grocery>();

const defaultColumns = [
  columnHelper.accessor('item', {
    header: 'Item',
  }),
  columnHelper.accessor('quantity', {
    header: 'Quantity',
  }),
  columnHelper.display({
    id: 'actions',
    header: 'Actions',
    cell: props => {
      return <DeleteButton id={props.row.original.id} />;
    },
  }),
];
export const GroceriesTable = () => {
  const { data = [] } = useGroceriesContext();

  const table = useReactTable({
    data,
    columns: defaultColumns,
    getCoreRowModel: getCoreRowModel(),
  });

  return <Table table={table}></Table>;
};

const DeleteButton: React.FC<{ id: number | undefined }> = ({ id }) => {
  const { deleteGrocery } = useGroceriesContext();

  const handleDelete = () => {
    if (id) deleteGrocery(id);
  };

  return <Remove onRemove={handleDelete} />;
};
